module.exports = "<div class=\"admin-group\">\r\n\t<header>\r\n\t\t<span class=\"group-name\"><%- data.name %></span>\r\n\t\t<span class=\"pull-right\">Rank: <%- data.rank %></span>\r\n\t</header>\r\n\t<div class=\"players-list\">\r\n\r\n\t</div>\r\n\t<button class=\"btn btn-xs btn-primary btn-add-player\">\r\n\t\tAdd Player to Group\r\n\t</button>\r\n\t<button class=\"btn btn-xs btn-danger btn-delete-group hidden\">\r\n\t\tDelete Group\r\n\t</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/admin-section/groups/group/group.tpl.html
// module id = 79
// module chunks = 0